module.exports = __webpack_public_path__ + "8aacfafa78527c3777c7e16abb37bd95.svg";